import { Hero } from './sections/Hero';
import { Stats } from './sections/Stats';
import { Pillars } from './sections/Pillars';
import { Pricing } from './sections/Pricing';
import { HowItWorks } from './sections/HowItWorks';
import { RequestAccess } from './sections/RequestAccess';

/**
 * The public landing page — the only route most visitors see today.
 *
 * Section order follows the funnel: the problem, who has it, what we built,
 * what it costs, how you get in, then the form. Request-access is last AND
 * linked from the header, so it is reachable without scrolling.
 */
export function LandingPage() {
  return (
    <>
      <Hero />
      <Stats />
      <Pillars />
      <Pricing />
      <HowItWorks />
      <RequestAccess />
    </>
  );
}
